import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { PreviousSearchItemMobile } from './PreviousSearchItemMobile';
import { getFilteredPreviousSearchesDepartureCities, getFilteredPreviousSearchesDestinationCities } from '../../redux/previousSearch/selectors';
import { LocationProp } from '../../models/Location';
import { FieldType, FieldTypeProps } from '../../models/FieldType';

export class PreviousSearchesMobile extends PureComponent {
    render() {
        const { maxLength, options, show, onClickItem, field, departureCities, destinationCities } = this.props;
        const previousSearches = field === FieldType.DEPARTURE ? departureCities : destinationCities;
        const citiesToRender = previousSearches.slice(0, maxLength);
        return (
            <React.Fragment>
                { show && citiesToRender.map((item, i) => (
                    <PreviousSearchItemMobile
                        key={item.iata}
                        index={i}
                        onClickItem={onClickItem}
                        value={item}
                        trackingId={options.trackingId}
                    />
                ))}
            </React.Fragment>
        );
    }
}

PreviousSearchesMobile.propTypes = {
    maxLength: PropTypes.number.isRequired,
    options: PropTypes.object,
    onClickItem: PropTypes.func,
    departureCities: PropTypes.arrayOf(LocationProp),
    destinationCities: PropTypes.arrayOf(LocationProp),
    show: PropTypes.bool,
    field: FieldTypeProps.isRequired,
};

PreviousSearchesMobile.defaultProps = {
    onClickItem: ()=>{},
    options: {},
    departureCities: [],
    destinationCities: [],
    show: true,
};

const mapStateToPropsSelector = createStructuredSelector({
    departureCities: getFilteredPreviousSearchesDepartureCities,
    destinationCities: getFilteredPreviousSearchesDestinationCities,
});

const ConnectedPreviousSearchesMobile = connect(mapStateToPropsSelector, {})(PreviousSearchesMobile);

ConnectedPreviousSearchesMobile.propTypes = {
    id: PropTypes.number.isRequired,
};

export { ConnectedPreviousSearchesMobile };
